import React, { useState } from 'react'
import {
    CreateScheduleRequest,
    ScheduleDetailActionThunk,
    UpdateScheduleRequest,
} from '../../../../store'
import { Company, Schedule } from '../../../../models'
import {
    Container,
    IconButton,
    Modal,
    Paper,
    Slide,
    Theme,
    Typography,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { ScheduleForm } from '../../../ScheduleHome/ViewComponents/ScheduleForm'
import { DateTime } from 'luxon'
import { useTimezone } from '../../../../contexts/timezone'

interface Props {
    open: boolean
    theme: Theme
    apartment: Company
    loading?: boolean
    onClose: () => void
    createSchedule: (req: CreateScheduleRequest) => ScheduleDetailActionThunk
    updateSchedule: (req: UpdateScheduleRequest) => ScheduleDetailActionThunk
    onCreateProject: () => void
    syncBedStatuses: (schedule: Schedule) => Promise<void>
    getUnitReport: (schedule: Schedule) => Promise<void>
}

export const CreateProjectModal = (props: Props) => {
    const {
        open,
        theme,
        loading,
        apartment,
        onClose,
        createSchedule,
        updateSchedule,
        onCreateProject,
    } = props

    const [color, setColor] = useState(theme.palette.primary.main)
    const { currentTimezone } = useTimezone()

    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            closeAfterTransition
        >
            <Slide direction="up" in={open}>
                <Paper
                    style={{
                        width: 'calc(100vw - 250px)',
                        backgroundColor: 'white',
                        height: 'calc(100vh - 150px)',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'scroll',
                        maxHeight: 'calc(100vh - 150px)',
                    }}
                >
                    <Container
                        maxWidth={false}
                        disableGutters
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '8px 16px',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                            width: '100%',
                        }}
                    >
                        <Typography variant="h6">
                            Create Project - {apartment.name}
                        </Typography>
                        <IconButton onClick={onClose} size="small">
                            <Close />
                        </IconButton>
                    </Container>
                    <ScheduleForm
                        {...props}
                        schedule={null}
                        color={color}
                        setColor={setColor}
                        initialStartDate={DateTime.now().setZone(
                            currentTimezone,
                            {
                                keepLocalTime: true,
                            },
                        )}
                        apartment={apartment}
                        userList={[]}
                        inspectionTypeList={[]}
                    />
                </Paper>
            </Slide>
        </Modal>
    )
}
